import { useState, useEffect, createContext, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { loaderContext } from "./LoaderProvider";
import socket from "../socket/socket";
export const authContext = createContext();

const AuthProvider = (props) => {
  const [isAuth, setIsAuth] = useState(null);
  const [merchantData, setMerchantData] = useState({});
  const { setIsLoading } = useContext(loaderContext);
  const navigate = useNavigate();
  const token = localStorage.getItem("wow-delivery-kw-merchant-token");

  const auth = () => {
    if (
      token !== "" &&
      token !== null &&
      token !== undefined &&
      token.length > 0
    ) {
      axios
        .get(process.env.REACT_APP_API_ENDPOINT + "merchant/auth", {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res && res.data.code === 1) {
            setMerchantData(res?.data?.data);
            if (localStorage.getItem("data-bs-theme") === null) {
              localStorage.setItem("data-bs-theme", "light");
            }
            if (
              res?.data?.data?.branchList?.length > 0 &&
              localStorage.getItem(
                "wow-delivery-kw-merchant-current-branch"
              ) === null
            ) {
              const currentBranch =
                res?.data?.data?.branchList
                  ?.filter((item) => item._id === res?.data?.data?.branchId)
                  ?.at(0) ?? res?.data?.data?.branchList?.at(0);
                  console.log(currentBranch)
              localStorage.setItem(
                "wow-delivery-kw-merchant-current-branch",
                JSON.stringify(currentBranch)
              );
            }
            if (
              res?.data?.data?.branchList?.length > 1 &&
              localStorage.getItem("wow-delivery-kw-merchant-branches") === null
            ) {
              localStorage.setItem(
                "wow-delivery-kw-merchant-branches",
                JSON.stringify(res?.data?.data?.branchList)
              );
            }
            setIsAuth(true);
            setIsLoading(false);
          } else {
            setIsAuth(false);
          }
        })
        .catch((err) => {
          setIsAuth(false);
          console.log(err);
        });
    } else {
      setIsAuth(false);
    }
  };

  useEffect(() => {
    auth();
    // eslint-disable-next-line
  }, [token, navigate, setIsLoading]);
  useEffect(() => {
    socket.on(`admin:merchantDataUpdate`, (data) => {
      if (data) {
        auth();
      }
    });
    socket.on(`merchant:balanceUpdate`, () => {
      auth();
    });
    return () => {
      socket.off(`admin:merchantDataUpdate`);
      socket.off(`merchant:balanceUpdate`);
    };
    // eslint-disable-next-line
  }, []);
  return (
    <authContext.Provider value={[isAuth, setIsAuth, merchantData]}>
      {props.children}
    </authContext.Provider>
  );
};

export default AuthProvider;
